import { useMemo, useState } from 'react';
import { match } from 'ts-pattern';
import { ZodType, z } from 'zod';
import { useLocalStorage } from './hooks/useLocalStorage';

/** Copy/pase to a global clipboard. Give a type so you don't get incompatible things pasting */
export const useCopy = <T extends ZodType,>({
  schema,
  type: typeRaw
}: {
  schema: T;
  type: string;
}) => {
  const [clip, setClip] = useLocalStorage({
    schema,
    key: 'clipboard'
  }); // was getting an infinite render with the mantine version of this. made my own
  // const [clip, setClip] = useState<z.infer<T> | undefined>(undefined)

  const type = typeRaw ?? schema.description;
  if (!type) throw new Error('useUIState requires a type, either as a property or as a schema description');
  const copy = (value?: z.infer<T>) => {
    setClip(value);
  };
  const pasteValue = useMemo(() => clip == null ? clip : match(schema.safeParse(clip)).with({
    success: true
  }, p => p.data as z.infer<T>).otherwise(() => undefined), [clip]);
  const clear = () => setClip(null);
  return {
    copy,
    pasteValue,
    clear,
    type
  };
};